import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching projects by user id
export const fetchProjectsByUserId = createAsyncThunk('projects/fetchProjectsByUserId', async (userId) => {
  const response = await fetch(`/api/projects/user/${userId}`);
  const data = await response.json();
  return data;
});

const projectsByUserIdSlice = createSlice({
  name: 'projects',
  initialState: { projects: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsByUserId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectsByUserId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projects = action.payload;
      })
      .addCase(fetchProjectsByUserId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default projectsByUserIdSlice.reducer;